import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BenefitIcon from "../components/BenefitIcons";
import "./Benefits.css";

const FILTERS = ["All", "Travel", "Protection", "Lifestyle", "Investment"];

const BENEFITS = [
  { id: "lounges", title: "Airport Lounges", highlight: "1,300+", subtitle: "Worldwide access", route: "/lounges", category: "Travel" },
  { id: "purchase-protection", title: "Purchase Protection", highlight: "90 days", subtitle: "Auto coverage", route: "/insurance", category: "Protection" },
  { id: "extended-warranty", title: "Extended Warranty", highlight: "+1 year", subtitle: "On every purchase", route: "/insurance", category: "Protection" },
  { id: "trip-insurance", title: "Travel Insurance", highlight: "$5K", subtitle: "8 coverage types", route: "/travel-insurance", category: "Travel" },
  { id: "visa-luxury-hotels", title: "Luxury Hotels", highlight: "900+", subtitle: "VIP perks included", route: "/hotels", category: "Travel" },
  { id: "car-rental", title: "Car Rental", highlight: "30% off", subtitle: "Elite status", route: "/car-rental", category: "Travel" },
  { id: "concierge", title: "Concierge", highlight: "24/7", subtitle: "Personal assistant", route: "/concierge", category: "Lifestyle" },
  { id: "stock-back", title: "Stock-Back", highlight: "5%", subtitle: "On every purchase", route: "/stock-back", category: "Investment" },
  { id: "gigsky", title: "eSIM Data", highlight: "3 GB", subtitle: "Free roaming", route: "/esim", category: "Lifestyle" },
  { id: "airrefund", title: "AirRefund", highlight: "€600", subtitle: "Delay compensation", route: "/airrefund", category: "Travel" },
  { id: "emergency-medical", title: "Emergency Medical", highlight: "24/7", subtitle: "Worldwide coverage", route: "/emergency-medical", category: "Protection" },
  { id: "loyalty-rewards", title: "Loyalty Rewards", highlight: "2x points", subtitle: "Earn on every swipe — redeem for travel & cash", route: null, category: "Lifestyle" },
];

const BENEFIT_PHOTOS = {
  "lounges": "https://images.unsplash.com/photo-1530521954074-e64f6810b32d?auto=format&fit=crop&w=430&h=190&q=80",
  "purchase-protection": "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=430&h=190&q=80",
  "extended-warranty": "https://images.unsplash.com/photo-1468495244123-6c6c332eeece?auto=format&fit=crop&w=430&h=190&q=80",
  "trip-insurance": "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?auto=format&fit=crop&w=430&h=190&q=80",
  "visa-luxury-hotels": "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=430&h=190&q=80",
  "car-rental": "https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=430&h=190&q=80",
  "concierge": "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=430&h=190&q=80",
  "stock-back": "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=860&h=380&q=95",
  "gigsky": "https://images.unsplash.com/photo-1512054502232-10a0a035d672?auto=format&fit=crop&w=430&h=190&q=80",
  "airrefund": "https://images.unsplash.com/photo-1569154941061-e231b4725ef1?auto=format&fit=crop&w=430&h=190&q=80",
  "emergency-medical": "https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?auto=format&fit=crop&w=430&h=190&q=80",
  "loyalty-rewards": "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=430&h=190&q=80",
};

function BenefitCard({ b }) {
  const photo = BENEFIT_PHOTOS[b.id];
  const inner = (
    <>
      {photo && (
        <div className="bc-photo-wrap">
          <img
            src={photo}
            alt={b.title}
            className={`bc-photo${b.id === "stock-back" ? " bc-photo-flipped" : ""}`}
          />
        </div>
      )}
      <div className="bc-content">
        <div className="bc-text">
          <span className="bc-title">{b.title}</span>
          <span className="bc-highlight">{b.highlight}</span>
          <span className="bc-subtitle">{b.subtitle}</span>
        </div>
        <span className="bc-arrow">›</span>
      </div>
    </>
  );
  if (b.route) return <Link to={b.route} className="benefit-card bc-photo-card">{inner}</Link>;
  return <div className="benefit-card bc-photo-card">{inner}</div>;
}

export default function Benefits() {
  const [activeFilter, setActiveFilter] = useState("All");
  const navigate = useNavigate();

  const filteredBenefits =
    activeFilter === "All"
      ? BENEFITS
      : BENEFITS.filter((b) => b.category === activeFilter);

  return (
    <div className="benefits-page">
      <section className="benefits-hero">
        <div className="hero-top">
          <div>
            <h1 className="benefits-title">Your Benefits</h1>
            <p className="benefits-tier">
              <span className="tier-dot" />
              Diamond member
            </p>
          </div>

        </div>
        <p className="benefits-value">
          Worth <strong>$12,000</strong>/year with your current tier
        </p>
      </section>

      <div className="benefits-filters">
        {FILTERS.map((filter) => (
          <button
            key={filter}
            type="button"
            className={`filter-tab ${activeFilter === filter ? "active" : ""}`}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>

      <div className="benefits-list">
        {filteredBenefits.map((b) => (
          <BenefitCard key={b.id} b={b} />
        ))}
      </div>

      <footer className="powered-by">Powered by Visa</footer>

      <div className="upsell-dock">
        <button className="upsell-banner" onClick={() => navigate("/unlock")} type="button">
          <div className="upsell-text">
            <span className="upsell-title">Unlock more benefits</span>
            <span className="upsell-sub">Customize your premium packs</span>
          </div>
          <span className="upsell-arrow">→</span>
        </button>
      </div>
    </div>
  );
}
